export const itSalesProgramData = {
	niveau1: {
		pageTitle: 'IT Sales - Niveau 1',
		programOption: 'IT Sales - Niveau 1',
		tabs: [
			{
				id: 'tab-1',
				label: 'Objectif',
				title: 'décrocher rapidement un premier poste en vente IT ',
				subtitle:
					'subtitlepermet d’acquérir les bases essentielles pour démarrer une carrière dans la vente IT, même sans expérience préalable.',
				items: [
					//{
					//	id: 'item-1',
					//	title: 'Introduction à la vente IT',
					//	content:
					//		'permet d’acquérir les bases essentielles pour démarrer une carrière dans la vente IT, même sans expérience préalable. ',
					//},
					//{
					//	id: 'item-2',
					//	title: 'Prospection commerciale',
					//	content:
					//		'Apprendre à identifier les prospects, construire une approche de contact et qualifier les besoins.',
					//},
				],
			},
			{
				id: 'tab-2',
				label: 'Programme ',
				title: 'Programme ',
				items: [
					{
						id: 'item-3',
						title: 'Introduction aux Technologies de l’Information ',
						content: `<ul>
						<li>Comprendre l’écosystème IT : cloud, cybersécurité, réseaux, data  </li>
						<li>Identifier les principaux acteurs du marché (Microsoft, AWS, Google…)  </li>
						<li>Comprendre le rôle stratégique de l’IT dans les entreprises  </li>
						</ul>,
						`,
					},
					{
						id: 'item-4',
						title: 'Cycle de vente IT ',
						content: `<ul>
						<li>Étapes clés : prospection → qualification → proposition → closing   </li>
						<li>Comprendre les spécificités des ventes IT (multi-interlocuteurs, cycles longs)   </li>
						<li>Introduction à la vente consultative    </li>
						</ul>,
						`,
					},

					{
						id: 'item-4',
						title: 'Prospection & génération de leads ',
						content: `<ul>
						<li>Prospection inbound & outbound    </li>
						<li>Social selling (LinkedIn, email, cold call)    </li>
						<li>Utilisation des outils CRM et automation     </li>
						<li>Qualification des leads (BANT, MEDDIC…)       </li>
						</ul>,
						`,
					},

					{
						id: 'item-5',
						title: 'Techniques de vente & communication  ',
						content: `<ul>
						<li>Écoute active et identification des besoins    </li>
						<li>Argumentation commerciale orientée valeur      </li>
						<li>Storytelling et pitch commercial      </li>
						<li>Gestion des objections       </li>
						</ul>,
						`,
					},
				],
			},

			{
				id: 'tab-3',
				label: 'Points forts  ',
				title: 'Points forts  ',
				items: [
					{
						id: 'item-6',
						title: 'À la fin du Niveau 1, l’apprenant est capable de :  ',
						content: `<ul>
						<li>Comprendre les solutions IT    </li>
						<li>Prospecter efficacement </li>
						<li>Qualifier des leads    </li>
						<li>Présenter une offre IT simple    </li>

						<li>Utiliser un CRM    </li>
						</ul>,
						`,
					},
					{
						id: 'item-7',
						title: 'Débouchés : ',
						content: `<ul>
						<li>Commercial IT junior    </li>
						<li>Business Developer    </li>
						<li>SDR (Sales Development Representative)     </li>
						</ul>,
						`,
					},
				],
			},
		],
	},

	niveau2: {
		pageTitle: 'IT Sales - Niveau 2',
		programOption: 'IT Sales - Niveau 2',
		tabs: [
			{
				id: 'tab-1',
				label: 'Objectif ',
				title: 'devenir un expert en vente IT complexe ',
				subtitle:
					'Le Niveau 2 permet de maîtriser les ventes à forte valeur ajoutée dans des environnements technologiques complexes (cloud, cybersécurité, SaaS…). ',
				items: [
					//{
					//	id: 'item-1',
					//	title: 'devenir un expert en vente IT complexe',
					//	content:
					//		'Apprendre à gérer des cycles longs, plusieurs décideurs et des offres à forte valeur.',
					//},
					//{
					//	id: 'item-2',
					//	title: 'Négociation commerciale',
					//	content:
					//		'Structurer une négociation, défendre la valeur et construire des accords gagnant-gagnant.',
					//},
				],
			},
			{
				id: 'tab-2',
				label: 'Programme',
				title: 'Programme',
				items: [
					{
						id: 'item-3',
						title: 'Techniques de présentation avancées ',
						content: `<ul>
						<li>Structurer une présentation impactante (AIDA)     </li>
						<li>Storytelling commercial   </li>
						<li>Démonstrations produit (Demo2Win)     </li>
						<li>Présentation en visio et hybride    </li>

						</ul>,
						`,
					},
					{
						id: 'item-4',
						title: 'Négociation avancée IT ',
						content: `<ul>
						<li>Méthodes : Harvard, BATNA, Challenger     </li>
						<li>Gestion des objections techniques et juridiques   </li>
						<li>Négociation des contrats (SaaS, cloud, SLA)   </li>
						<li>Gestion des conflits      </li>

						</ul>,
						`,
					},

					{
						id: 'item-5',
						title: ' Finance & gestion commerciale  ',
						content: `<ul>
						<li>Calcul du ROI et TCO      </li>
						<li>Analyse de rentabilité    </li>
						<li>Pricing et marges  </li>
						<li>Excel appliqué à la vente       </li>

						</ul>,
						`,
					},

					{
						id: 'item-6',
						title: 'Aspects juridiques IT  ',
						content: `<ul>
						<li>Contrats IT (SaaS, licences, cloud)      </li>
						<li>RGPD et protection des données    </li>
						<li>Clauses contractuelles et SLA    </li>


						</ul>,
						`,
					},

					{
						id: 'item-7',
						title: 'Pilotage de la performance commerciale  ',
						content: `<ul>
						<li>KPIs et dashboards     </li>
						<li>Forecasting     </li>
						<li>Gestion du pipeline   </li>
						<li>Reporting commercial    </li>

						</ul>,
						`,
					},

					{
						id: 'item-8',
						title: 'Gestion de projet & relation client  ',
						content: `<ul>
						<li>Suivi post-vente       </li>
						<li>Fidélisation client     </li>
						<li>Gestion des incidents    </li>

	<li>Services après-vente      </li>
						</ul>,
						`,
					},

					{
						id: 'item-9',
						title: 'Influence & stratégie commerciale  ',
						content: `<ul>
						<li>Psychologie de la décision       </li>
						<li>Social engineering éthique     </li>
						<li>Cartographie des décideurs     </li>

						<li>Lobbying commercial     </li>
						</ul>,
						`,
					},

					{
						id: 'item-10',
						title: 'Mises en situation & pratique  ',
						content: `<ul>
						<li>Simulations de vente complètes       </li>
						<li>Cas réels IT (cloud, cybersécurité…)     </li>
						<li>Présentations devant jury     </li>
						<li>Coaching personnalisé      </li>
						</ul>,
						`,
					},
				],
			},

			{
				id: 'tab-3',
				label: 'Résultats après Niveau 2 ',
				title: 'Résultats après Niveau 2 ',
				items: [
					{
						id: 'item-11',
						title:
							'À l’issue du programme complet, l’apprenant est capable de : ',
						content: `<ul>
						<li>Gérer un cycle de vente IT complet      </li>
						<li>Négocier des contrats complexes   </li>
						<li>Piloter un portefeuille clients      </li>
						<li>Vendre des solutions technologiques avancées     </li>

						</ul>,
						`,
					},
					{
						id: 'item-12',
						title: 'Débouchés : ',
						content: `<ul>
						<li>Account Executive      </li>
						<li>Business Developer IT     </li>
						<li>Ingénieur commercial    </li>
						<li>Consultant IT Sales      </li>

						</ul>,
						`,
					},
				],
			},
		],
	},
};
